export const NUMBERS = '0123456789';
export const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
export const UPPERCASE = LOWERCASE.toUpperCase();
export const LETTERS = LOWERCASE + UPPERCASE;
export function makeValidCharacterSet(text, validCharacters, invalidCharacters) {
    if (!text) {
        return text;
    }
    return text
        .split('')
        .filter((x) => (!validCharacters || validCharacters.indexOf(x) >= 0) && (!invalidCharacters || invalidCharacters.indexOf(x) < 0))
        .join('');
}
